import * as React from 'react';
import { ConfirmationDialog, ConfirmationOptions } from './ConfirmationDialog';
import { ReactNode } from 'react';

// TODO move this common library copied from MMM
const ConfirmationServiceContext = React.createContext<(options: ConfirmationOptions) => Promise<void>>(Promise.reject);

export const useConfirmation = (): ((options: ConfirmationOptions) => Promise<void>) => React.useContext(ConfirmationServiceContext);

export const ConfirmationServiceProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [confirmationState, setConfirmationState] = React.useState<ConfirmationOptions | null>(null);

  const awaitingPromiseRef = React.useRef<{
    resolve: () => void;
    reject: () => void;
  }>();

  const openConfirmationOptions = React.useCallback((options: ConfirmationOptions) => {
    setConfirmationState(options);
    return new Promise<void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  }, []);

  const onClose = React.useCallback(() => {
    if (confirmationState?.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    setConfirmationState(null);
  }, [confirmationState?.catchOnCancel]);

  const onSubmit = React.useCallback(() => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }

    setConfirmationState(null);
  }, []);

  return (
    <>
      <ConfirmationServiceContext.Provider value={openConfirmationOptions}>
        <span>{children}</span>
      </ConfirmationServiceContext.Provider>

      <ConfirmationDialog open={Boolean(confirmationState)} onSubmit={onSubmit} onClose={onClose} {...confirmationState} />
    </>
  );
};
